import { useMutation } from '@tanstack/react-query';
import { desktopAuthApi } from './desktop-auth.api';
import type {
  DesktopAuthorizeDecision,
  DesktopAuthorizeParams,
} from '../types/desktop-auth.type';

/**
 * 허용·거절 후 서버가 준 루프백 URL 로 이동한다.
 * 화면 전환이 아니라 XCOST 로 결과를 넘기는 것이라 SPA navigate 가 아니다.
 */
export function useDesktopAuthorizeDecision(params: DesktopAuthorizeParams) {
  return useMutation({
    mutationFn: ({
      decision,
      deviceNickname,
    }: {
      decision: DesktopAuthorizeDecision;
      deviceNickname?: string;
    }) => desktopAuthApi.decide(params, decision, deviceNickname),
    onSuccess: ({ redirectUrl }) => {
      window.location.assign(redirectUrl);
    },
  });
}
